var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalSignature({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9874 7.35111L11.6664 17.6711L7.60489 13.6096L8.96639 12.2511L11.6664 14.9511L21.0294 5.58762C20.1343 4.30534 18.9382 3.26225 17.5462 2.54978C16.1541 1.83731 14.6085 1.47724 13.0449 1.50111C10.1696 1.55287 7.41289 2.65636 5.29607 4.60293C3.17924 6.5495 1.84901 9.20422 1.55689 12.0651C1.40923 13.4101 1.5498 14.7711 1.96924 16.0575C2.38867 17.3439 3.07735 18.5262 3.98942 19.5256C4.90149 20.5251 6.01602 21.3187 7.25879 21.8538C8.50156 22.3888 9.84406 22.653 11.1969 22.6286C14.0721 22.5769 16.8288 21.4734 18.9456 19.527C21.0624 17.5805 22.3927 14.9259 22.6849 12.0651C22.8347 10.4606 22.5955 8.84352 21.9874 7.35111Z",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalSignature);
export default __webpack_public_path__ + "static/media/digital-signature.120f32e095b7ad13c86832bfe40588b2.svg";
export { ForwardRef as ReactComponent };